import React from 'react';

const OnlineApplications = () => {
  return (
    <div>
      OnlineApplications
      OnlineApplications
    </div>
  );
}

export default OnlineApplications;
